{
    "ChanneltypesLabel": "Tipo(i) di canale:",
    "ChanneltypesOptionAny": "[Qualsiasi canale]",
    "ChanneltypesOptionVoice": "Chiamate vocali",
    "ChanneltypesOptionChat": "Chat",
    "ChanneltypesOptionEmail": "Email",
    "CalltypedirectionLabel": "Tipo di chiamata \/ Direzione:",
    "CalltypedirectionOptionAny": "[Qualsiasi tipo di chiamata]",
    "CalltypedirectionOptionUnknownorinitiating": "[Sconosciuto o iniziatore]",
    "CalltypedirectionOptionInbound": "Solo in entrata",
    "CalltypedirectionOptionOutbound": "Solo in uscita",
    "CalltypedirectionOptionExternalAll": "Solo esterno",
    "CalltypedirectionOptionExternalInbound": "Esterno (solo in entrata)",
    "CalltypedirectionOptionExternalOutbound": "Esterno (solo in uscita)",
    "CalltypedirectionOptionExternalTrktotrk": "Trunk-To-Trunk esterno",
    "CalltypedirectionOptionInternalAll": "Solo interno",
    "CalltypedirectionOptionInternalInbound": "Interno (solo in entrata)",
    "CalltypedirectionOptionInternalOutbound": "Interno (solo in uscita)",
    "AnswertypeLabel": "Tipo di risposta:",
    "ClicalleridreceivedAny": "[Any]",
    "ClicalleridreceivedNone": "Senza CLI\/CallerID",
    "ClicalleridreceivedReceived": "Con CLI\/CallerID",
    "AnswertypeOptionAny": "[Qualsiasi tipo di risposta]",
    "AnswertypeOptionNotans": "Non risponde",
    "AnswertypeOptionAns": "Rispondere",
    "AnswertypeOptionAbandoned": "Abbandonato",
    "AnswertypeOptionAdvancedFrom": "Avanzato Da",
    "AnswertypeOptionAdvancedTo": "Avanzato a",
    "AnswertypeOptionOverflowedFrom": "Traboccato Spento",
    "AnswertypeOptionOverflowedTo": "Tracimato in",
    "ClicalleridreceivedLabel": "CLI \/ ID chiamante ricevuto:",
    "DiddigitsLabel": "Cifre DDI:",
    "AccountcodesLabel": "Codice(i) del conto:",
    "CallidentifierLabel": "Identificatore di chiamata (piattaforma di telefonia):",
    "SubjectfilterLabel": "Filtro soggetto:",
    "TreatconfcallasExternalLabel": "Trattare la teleconferenza come esterna:",
    "MiscellaneousFiltering_SectionHeader": "Filtri vari",
    "MiscellaneousFiltering_AnyPlaceholder": "[Any]",
    "NAME": "MiscellaneousFiltering"
}